import { render } from "./AppInitLayout.vue?vue&type=template&id=4a54b3f2"
import script from "./AppInitLayout.vue?vue&type=script&lang=js"
export * from "./AppInitLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__